import React, { useContext } from 'react';
import './ProgressBar.module.scss';
import { QuizContext } from 'screens/Quiz/Quiz';
import { motion } from 'framer-motion';

export default function ProgressBar() {
    const { questionIndex } = useContext(QuizContext);

    const width = (100 / 5) * (questionIndex - 1);
    return (
        <div styleName="progress-bar">
            <p>Vraag {questionIndex}</p>
            <div styleName="bar">
                <motion.div
                    // animate={{
                    //     width: `${width}%`,
                    // }}
                    style={{ width: `${width}%` }}
                    styleName="progress"
                />
            </div>
            <p>van de 5</p>
        </div>
    );
}
